import _classCallCheck from "/Users/eddieruiz/2024AiNomads/NomadHub/AiNomadsHub/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/eddieruiz/2024AiNomads/NomadHub/AiNomadsHub/node_modules/@babel/runtime/helpers/esm/createClass";
import { ClickEvent } from "./ClickEvent";
import { DivEvent } from "./DivEvent";
import { HoverEvent } from "./HoverEvent";
export var Events = /*#__PURE__*/function () {
  function Events() {
    _classCallCheck(this, Events);
    this.onClick = new ClickEvent();
    this.onDiv = new DivEvent();
    this.onHover = new HoverEvent();
    this.resize = true;
  }
  _createClass(Events, [{
    key: "onclick",
    get: function get() {
      return this.onClick;
    },
    set: function set(value) {
      this.onClick = value;
    }
  }, {
    key: "ondiv",
    get: function get() {
      return this.onDiv;
    },
    set: function set(value) {
      this.onDiv = value;
    }
  }, {
    key: "onhover",
    get: function get() {
      return this.onHover;
    },
    set: function set(value) {
      this.onHover = value;
    }
  }, {
    key: "load",
    value: function load(data) {
      var _a, _b, _c;
      if (data === undefined) {
        return;
      }
      this.onClick.load((_a = data.onClick) !== null && _a !== void 0 ? _a : data.onclick);
      var onDiv = (_b = data.onDiv) !== null && _b !== void 0 ? _b : data.ondiv;
      if (onDiv !== undefined) {
        if (onDiv instanceof Array) {
          this.onDiv = onDiv.map(function (div) {
            var tmp = new DivEvent();
            tmp.load(div);
            return tmp;
          });
        } else {
          this.onDiv = new DivEvent();
          this.onDiv.load(onDiv);
        }
      }
      this.onHover.load((_c = data.onHover) !== null && _c !== void 0 ? _c : data.onhover);
      if (data.resize !== undefined) {
        this.resize = data.resize;
      }
    }
  }]);
  return Events;
}();